module.exports = "/_next/static/images/173ce24c1bcaa4c313d08f975b1b3037-nucommunity-xs@2x.jpg.webp";